<template>
  <vx-card
    id="app_body"
    class="flex-1 flex-col w-full lg:ml-base relative overflow-x-hidden"
  >
    <template slot="no-body">
      <global-header :buttonBack="true" :actions="false"></global-header>
      <div class="w-full">
        <router-view></router-view>
      </div>
    </template>
  </vx-card>
</template>

<script>
import EditInbox from "./EditInbox.vue";

import { mapState } from "vuex";

export default {
  components: {
    EditInbox
  },
  computed: {
    ...mapState({
      edit: state => state.surat.edit
    })
  }
};
</script>
